export type ProjectListItem = { id: number; name?: string };

export function normalizeProjectsList(data: unknown): ProjectListItem[] {
    if (Array.isArray(data)) return data as ProjectListItem[];
    if (
        data &&
        typeof data === "object" &&
        "data" in data &&
        Array.isArray((data as { data: unknown }).data)
    ) {
        return (data as { data: ProjectListItem[] }).data;
    }
    return [];
}
